import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { Badge } from '../ui/badge';

const faqs = [
  {
    question: 'Is there a replacement for therapy?',
    answer:
      'No, Human Potential OS is not a replacement for professional therapy or mental health treatment. It is a self-discovery tool designed to help you understand your personality traits, strengths, and growth areas. If you are experiencing mental health challenges, please consult with a qualified healthcare professional.',
  },
  {
    question: 'How long does the assessment take?',
    answer:
      'The complete Human Potential OS assessment typically takes 15-20 minutes to complete. We recommend finding a quiet time when you can focus without distractions to get the most accurate results.',
  },
  {
    question: 'Is my personal health data safe?',
    answer:
      'Yes, your data privacy and security are our top priorities. We use industry-standard encryption and never share your personal information with third parties. Your assessment results are stored securely and only accessible to you and any coaches you choose to share them with.',
  },
  {
    question: 'Can I use Human Potential OS for free?',
    answer:
      'Yes, we offer a free assessment experience that includes your basic personality profile. Premium features like detailed AI analysis, coach connections, and progress tracking are available through our subscription plans.',
  },
  {
    question: 'What devices can I use Human Potential OS on?',
    answer:
      'Human Potential OS is a web-based application that works on any device with a modern web browser, including desktop computers, laptops, tablets, and smartphones. Your progress syncs automatically across all your devices.',
  },
];

export function FAQSection() {
  return (
    <section id="faq" className="py-20 md:py-28 px-4 md:px-8 bg-white">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-12">
          <Badge variant="brand" className="mb-4">
            FAQ
          </Badge>
          <h2 className="text-3xl md:text-heading-md font-bold text-brand-90 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-paragraph-xl text-gray-60">
            Have any questions? Please see below first section.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left text-lg">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-paragraph-md">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
